import ProductsByCategoryAdvancedView from './ProductsByCategoryAdvancedView'

export default ProductsByCategoryAdvancedView
